import { GenericStatus } from "./props";

const PaymentsStatus: GenericStatus[] = [
    {key: "paid", text: "Paid", tagVariant: 'success'},
    {key: "unpaid", text: "Unpaid", tagVariant: 'error'}
]

export default PaymentsStatus;